import store from "store"
import { UpdateFolderRequest } from "suus-api"
import { computed } from "vue"

/**
 *  The point of this file is to provide "Killers" that first just wrap the vuex-store calls.
 *  When all relevant components are referencing these killers instead of directly calling the store,
 *  we can replace the store with an own state management solution.
 *  This way we can kill the store without changing the components.
 *  Afterward the killers can be easily renamed and moved by using the IDE's refactoring tools.
 */

export const DriveVuexKiller = {
  createFolder: async (folderData: UpdateFolderRequest) => {
    return store.dispatch("drive/createFolder", folderData)
  },
  updateInode: async (update_url: string, folderData: UpdateFolderRequest) => {
    // The update-url is plumbed here, so we dont have a dependency on inode.
    // TODO: Refactor to use the inode id & the generated API-client. (when store is safe be killed)
    return store.dispatch("drive/updateInode", {
      inode: { update_url },
      formData: folderData,
    })
  },
  setDriveSuccess: (message: string) => {
    store.commit("drive/setSuccess", message)
  },
  driveError: computed(() => store.getters["drive/error"]),
  setDriveError: (error: unknown) => {
    store.commit("drive/setError", error)
  },
}
